/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import type {
  Error,
  ListAccountVisitorsParams,
  ListSiteVisitorsParams,
  SiteID,
  VisitorsResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns daily unique visitors across your entire account for a required date range, plus the period total.
 * @summary Get account visitor stats
 */
export const listAccountVisitors = (params: ListAccountVisitorsParams, signal?: AbortSignal) => {
  return customFetch<VisitorsResponse>({
    url: `/v1/account/visitors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAccountVisitorsQueryKey = (params?: ListAccountVisitorsParams) => {
  return [`/v1/account/visitors`, ...(params ? [params] : [])] as const;
};

export const getListAccountVisitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountVisitorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountVisitors>>> = ({ signal }) =>
    listAccountVisitors(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/account/visitors`,
      operationId: 'app.controllers.visitors_controller.list_account_visitors',
      operationName: 'listAccountVisitors',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAccountVisitorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountVisitors>>
>;
export type ListAccountVisitorsQueryError = Error;

export function useListAccountVisitors<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountVisitors>>,
          TError,
          Awaited<ReturnType<typeof listAccountVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountVisitors<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountVisitors>>,
          TError,
          Awaited<ReturnType<typeof listAccountVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountVisitors<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get account visitor stats
 */

export function useListAccountVisitors<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountVisitorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAccountVisitorsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountVisitorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountVisitors>>> = ({ signal }) =>
    listAccountVisitors(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/account/visitors`,
      operationId: 'app.controllers.visitors_controller.list_account_visitors',
      operationName: 'listAccountVisitors',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAccountVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAccountVisitorsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountVisitors>>
>;
export type ListAccountVisitorsSuspenseQueryError = Error;

export function useListAccountVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get account visitor stats
 */

export function useListAccountVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listAccountVisitors>>,
  TError = Error,
>(
  params: ListAccountVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAccountVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountVisitorsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns daily unique visitor counts for one site over an optional date range, plus the period total.
 * @summary Get site visitor stats
 */
export const listSiteVisitors = (
  id: SiteID,
  params?: ListSiteVisitorsParams,
  signal?: AbortSignal
) => {
  return customFetch<VisitorsResponse>({
    url: `/v1/sites/${id}/visitors`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteVisitorsQueryKey = (id?: SiteID, params?: ListSiteVisitorsParams) => {
  return [`/v1/sites/${id}/visitors`, ...(params ? [params] : [])] as const;
};

export const getListSiteVisitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteVisitorsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteVisitors>>> = ({ signal }) =>
    listSiteVisitors(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/visitors`,
      operationId: 'app.controllers.visitors_controller.list_site_visitors',
      operationName: 'listSiteVisitors',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteVisitorsQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteVisitors>>>;
export type ListSiteVisitorsQueryError = Error;

export function useListSiteVisitors<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteVisitorsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteVisitors>>,
          TError,
          Awaited<ReturnType<typeof listSiteVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteVisitors<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteVisitors>>,
          TError,
          Awaited<ReturnType<typeof listSiteVisitors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteVisitors<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site visitor stats
 */

export function useListSiteVisitors<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteVisitorsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteVisitorsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteVisitorsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteVisitors>>> = ({ signal }) =>
    listSiteVisitors(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/visitors`,
      operationId: 'app.controllers.visitors_controller.list_site_visitors',
      operationName: 'listSiteVisitors',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteVisitors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteVisitorsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteVisitors>>
>;
export type ListSiteVisitorsSuspenseQueryError = Error;

export function useListSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteVisitorsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site visitor stats
 */

export function useListSiteVisitorsSuspense<
  TData = Awaited<ReturnType<typeof listSiteVisitors>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteVisitorsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteVisitors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteVisitorsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
